// Status lesbar machen statt Rohwerte wie „accepted_by_student“ (T-0202).

const ANMELDUNG: Record<string, string> = {
  draft: 'Entwurf',
  sent: 'Angebot verschickt',
  accepted_by_student: 'Vom Kunden angenommen',
  rejected_by_student: 'Vom Kunden abgelehnt',
  converted: 'Aktiv',
  active: 'Aktiv',
  cancelled: 'Storniert',
  ended: 'Beendet',
  terminated: 'Gekündigt',
};

const ALLGEMEIN: Record<string, string> = {
  open: 'Offen',
  pending: 'Ausstehend',
  in_progress: 'In Bearbeitung',
  done: 'Erledigt',
  completed: 'Abgeschlossen',
  closed: 'Geschlossen',
  failed: 'Fehlgeschlagen',
};

/** Aus einem Schlüssel wie „vertragsanpassung_offen“ wird „Vertragsanpassung offen“. */
export function lesbar(wert: string | null | undefined): string {
  const roh = String(wert ?? '').trim();
  if (!roh) return '—';
  const bekannt = ALLGEMEIN[roh.toLowerCase()];
  if (bekannt) return bekannt;
  const text = roh.replace(/[_-]+/g, ' ');
  return text.charAt(0).toUpperCase() + text.slice(1);
}

export function anmeldungStatusText(status: string | null | undefined): string {
  return ANMELDUNG[String(status ?? '').trim().toLowerCase()] ?? lesbar(status);
}
